function sizeMenu(){

    "use strict";

    var SIZE_ITEM = '.size-menu__btn',
        SELECTOR_BAR = '.selector__bar',
        COLLAPSER_EXPANDED = 'collapser--expanded';

    $( SIZE_ITEM ).on('click', onClick);

    function onClick(event) {
        var $sizeValue = this.getAttribute('data-value');
        var $collapser = $('#' + this.getAttribute('data-targetgroup'));
        $( SELECTOR_BAR + '[data-target=' + this.getAttribute('data-targetgroup') + ']').each(function (index) {
            $(this).toggleClass(COLLAPSER_EXPANDED);

            $(this).find('.selector__bar--value span:first-of-type').html($sizeValue);

            if ($collapser.length) {

                $collapser.height($collapser[0].scrollHeight);
                $collapser.toggleClass(COLLAPSER_EXPANDED);

                if (!$collapser.hasClass(COLLAPSER_EXPANDED)) {

                    $collapser.animate({
                        height: 0
                    }, 400);

                } else {

                    $collapser.height(0);

                    $collapser.animate({
                        height: $collapser[0].scrollHeight
                    }, 400, function () {
                        $collapser.height('auto');
                    });
                }

            }
        });
    }

}

module.exports = sizeMenu;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/10_size-menu.js